import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Formik } from 'formik'
import { FormGroup } from 'react-bootstrap'
import ATInput from '../../components/common/formComponent/ATInput'
import ATTextButton from '../../components/common/formComponent/ATTextButton'
import bg from '../../assets/login_bg.png'
import logo from '../../assets/images/atlas_logo.svg'
import * as Yup from 'yup'
import { MdOutlineInfo } from 'react-icons/md'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useFirefighterLogin } from '../../customHooks/auth/useFirefighterLogin'
import './FirefighterLogin.css'

const FirefighterLogin: React.FC = () => {
  const { t } = useTranslation(['translation'])
  const [showPassword, setShowPassword] = useState(false)
  const { handleLogin } = useFirefighterLogin()

  return (
    <div
      className="firefighter-login vh-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="col-11 col-sm-8 col-md-6 col-lg-4">
        <div className="card shadow-sm px-4 pt-5 pb-3">
          <img
            alt="companyLogo"
            src={logo}
            height={60}
            className="d-block mx-auto mb-3"
          />
          <Formik
            validateOnMount={true}
            initialValues={{
              emailId: '',
              password: '',
            }}
            validationSchema={Yup.object({
              emailId: Yup.string()
                .email(t('form.email_invalid_message'))
                .required(t('form.required_field_message')),
              password: Yup.string().required(t('form.required_field_message')),
            })}
            onSubmit={(values, { setSubmitting }) => {
              handleLogin(values.emailId, values.password, () =>
                setSubmitting(false),
              )
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isValid,
              dirty,
              isSubmitting,
            }) => (
              <div>
                <FormGroup className="col-md-12 col-12">
                  <ATInput
                    label={t('login.email_address')}
                    name="emailId"
                    placeholder=""
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    value={values?.emailId}
                    isError={!!(errors?.emailId && touched?.emailId)}
                    error={errors?.emailId}
                    isMandatory={true}
                  />
                </FormGroup>
                <FormGroup className="col-md-12 col-12">
                  <ATInput
                    label={t('login.password')}
                    name="password"
                    placeholder=""
                    type={showPassword ? 'text' : 'password'}
                    onChangeHandler={handleChange}
                    onBlurHandler={handleBlur}
                    value={values?.password}
                    isError={!!(errors?.password && touched?.password)}
                    error={errors?.password}
                    isMandatory={true}
                    rightIcon={
                      <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{ cursor: 'pointer' }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    }
                  />
                </FormGroup>
                <div className="d-flex justify-content-center mt-3">
                  <ATTextButton
                    title={
                      isSubmitting ? t('login.loading') : t('login.sign_in')
                    }
                    onPressHandler={handleSubmit}
                    disabled={!(isValid && dirty) || isSubmitting}
                    customClassName={'w-50'}
                  />
                </div>
                <div className="d-flex align-items-start mt-4">
                  <MdOutlineInfo size={24} style={{ marginTop: '-2px' }} />
                  <span className="ps-1 select-capability-note">
                    <strong style={{ fontWeight: 800, fontSize: 14 }}>
                      {t('common.note')}:{' '}
                      {t('login.emergency_login_credential_message')}
                    </strong>
                  </span>
                </div>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default FirefighterLogin
